import { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [authed, setAuthed] = useState(null); // null = checking

  useEffect(() => {
    const token = localStorage.getItem("agnes_admin_token");
    if (!token) {
      setAuthed(false);
      return;
    }
    api
      .get("/admin/me")
      .then(() => setAuthed(true))
      .catch(() => {
        localStorage.removeItem("agnes_admin_token");
        setAuthed(false);
      });
  }, []);

  const login = async (password) => {
    const { data } = await api.post("/admin/login", { password });
    localStorage.setItem("agnes_admin_token", data.token);
    setAuthed(true);
  };

  const logout = () => {
    localStorage.removeItem("agnes_admin_token");
    setAuthed(false);
  };

  return (
    <AuthContext.Provider value={{ authed, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
